import { useContext, useEffect } from 'react';

import {
  AtomMap,
  getActiveAssetIconFromSchemaMarkerId,
  getGoogleShapeCenter,
  getInactiveAssetIconFromSchemaMarkerId,
  trimPointLatLng,
  useDefaultMapLocation,
  useReverseGeocoder,
} from '@atom/map';
import { GeoJSONGeometry, LocationGeometry } from '@atom/types/geojson';
import { EditTarget } from '@atom/types/map';
import { getColorFromColorId } from '@atom/utilities/colorUtilities';

import CreateAssetModalContext from '../CreateAssetModalContext';

const INITIAL_ZOOM = 15;
const DECIMAL_ACCURACY = 6;

const LineLocationTabMap = () => {
  const { location, setLocation, setAddress, schema } = useContext(
    CreateAssetModalContext,
  );
  const defaultLocation = useDefaultMapLocation();
  const reverseGeocode = useReverseGeocoder();

  const geometry =
    location?.coordinates !== null && location?.coordinates !== undefined
      ? (location as GeoJSONGeometry)
      : null;
  const geometryCenter = geometry ? getGoogleShapeCenter(geometry) : null;
  const center = geometryCenter ?? defaultLocation.center;

  useEffect(() => {
    const geocodeCenter = geometry ? getGoogleShapeCenter(geometry) : null;

    if (!geocodeCenter) {
      return undefined;
    }

    const controller = new AbortController();

    const updateAddress = async () => {
      const address = await reverseGeocode(geocodeCenter);

      if (!controller.signal.aborted) {
        setAddress(address);
      }
    };

    updateAddress();

    return () => controller.abort();
  }, [geometry, reverseGeocode, setAddress]);

  const target: EditTarget = {
    id: 'create',
    type: 'asset',
    icon: (
      <img
        src={getInactiveAssetIconFromSchemaMarkerId(schema.markerId)}
        alt=""
      />
    ),
    activeIcon: (
      <img src={getActiveAssetIconFromSchemaMarkerId(schema.markerId)} alt="" />
    ),
    color: getColorFromColorId(schema.markerId),
    location: geometry,
    canEdit: true,
  };

  const handleChange = (next: LocationGeometry | null) => {
    if (next) {
      setLocation(trimPointLatLng(next, DECIMAL_ACCURACY));
    }
  };

  return (
    <AtomMap
      initialViewState={{ center, zoom: INITIAL_ZOOM }}
      compactToolbars
      editing={{
        targets: [target],
        lockMode: 'linestring',
        autoEdit: true,
        autoCommit: true,
        onChange: handleChange,
        onSave: () => {},
      }}
    />
  );
};

export default LineLocationTabMap;
